var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilizationBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 131.5C22 133.985 24.0147 136 26.5 136V136C28.9853 136 31 133.985 31 131.5L31 46.7648C31 44.2795 28.9853 42.2648 26.5 42.2648V42.2648C24.0147 42.2648 22 44.2795 22 46.7648L22 131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 131.5C39 133.985 41.0147 136 43.5 136V136C45.9853 136 48 133.985 48 131.5V81.6662C48 79.1809 45.9853 77.1662 43.5 77.1662V77.1662C41.0147 77.1662 39 79.1809 39 81.6662V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 131.5C90 133.985 92.0147 136 94.5 136V136C96.9853 136 99 133.985 99 131.5V79.5C99 77.0147 96.9853 75 94.5 75V75C92.0147 75 90 77.0147 90 79.5V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 131.5C56 133.985 58.0147 136 60.5 136V136C62.9853 136 65 133.985 65 131.5V93.6324C65 91.1471 62.9853 89.1324 60.5 89.1324V89.1324C58.0147 89.1324 56 91.1471 56 93.6324V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 131.5C73 133.985 75.0147 136 77.5 136V136C79.9853 136 82 133.985 82 131.5V56.7366C82 54.2513 79.9853 52.2366 77.5 52.2366V52.2366C75.0147 52.2366 73 54.2513 73 56.7366V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 131.5C107 133.985 109.015 136 111.5 136V136C113.985 136 116 133.985 116 131.5V95.5C116 93.0147 113.985 91 111.5 91V91C109.015 91 107 93.0147 107 95.5V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 131.5C125 133.985 127.015 136 129.5 136V136C131.985 136 134 133.985 134 131.5V79.5C134 77.0147 131.985 75 129.5 75V75C127.015 75 125 77.0147 125 79.5V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 131.5C142 133.985 144.015 136 146.5 136V136C148.985 136 151 133.985 151 131.5V57.5C151 55.0147 148.985 53 146.5 53V53C144.015 53 142 55.0147 142 57.5V131.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159 136.5C159 138.985 161.015 141 163.5 141V141C165.985 141 168 138.985 168 136.5V59.5C168 57.0147 165.985 55 163.5 55V55C161.015 55 159 57.0147 159 59.5V136.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 136.5C176 138.985 178.015 141 180.5 141V141C182.985 141 185 138.985 185 136.5V68.5C185 66.0147 182.985 64 180.5 64V64C178.015 64 176 66.0147 176 68.5V136.5Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizationBarChart);
export default __webpack_public_path__ + "static/media/UtilizationBarChart.bfebd23e6734bb7d1cb98b616018a82c.svg";
export { ForwardRef as ReactComponent };